<section class="section white-100" *ngIf="stats?.length">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-48">
      Built for lasting financial operations
    </h2>
    <div class="section-helping-businesses-container">
      <div
        class="grey-100 section-helping-businesses"
        *ngFor="let stat of stats"
      >
        <figure class="display-c">
          <img
            src="{{ stat?.fields?.imageicon?.fields?.file?.url }}"
            class="ico-48"
            alt="{{ stat?.fields?.imageicon?.fields?.title }}"
          />
        </figure>
        <div class="helping-businesses">
          <div
            class="product-blog-heading"
            [innerHtml]="stat?.fields?.description | toHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
